import { render, staticRenderFns } from "./CertificatsListPage.vue?vue&type=template&id=2f1eaec5&scoped=true&"
import script from "./CertificatsListPage.vue?vue&type=script&lang=js&"
export * from "./CertificatsListPage.vue?vue&type=script&lang=js&"
import style0 from "./CertificatsListPage.vue?vue&type=style&index=0&id=2f1eaec5&scoped=true&lang=css&"
import style1 from "./CertificatsListPage.vue?vue&type=style&index=1&id=2f1eaec5&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1eaec5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f1eaec5')) {
      api.createRecord('2f1eaec5', component.options)
    } else {
      api.reload('2f1eaec5', component.options)
    }
    module.hot.accept("./CertificatsListPage.vue?vue&type=template&id=2f1eaec5&scoped=true&", function () {
      api.rerender('2f1eaec5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/CertificatsListPage.vue"
export default component.exports